import React, { DetailedHTMLProps, useMemo } from "react"


const Button = React.forwardRef<HTMLButtonElement, Props>( ( { className: _className, ...props }, ref ) => {

    const className = useMemo( () => {

        return [
            'w-full focus:outline-none h-10 bord flex ',
            'items-center justify-center cursor-pointer ',
            'rounded-md text-center px-4 py-2 ',
            'bg-primary ',
            ...( _className?.split( ' ' ) ?? [] )
        ].join( ' ' )
    }, [ _className ] )

    return (
        <input
            className={ className }
            type="button"
            { ...props }
        />
    )
})

interface Props extends DetailedHTMLProps<any, HTMLButtonElement> {

}

export { Button }
